import { LOAD_OPTIONS_SUCCESS } from '@gcc/configurator/dist/actions/actionTypes';
import { dollars } from '@gcc/pip-components/dist/utils/formatCurrency';
import { UPDATE_QUICK_VIEW_PRICING } from '../actions/actionTypes';
import getTagsOfType from '../utils/tags/getTagsOfType';

const initialState = {
  skus: {},
  choices: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_OPTIONS_SUCCESS: {
      const { choices: configChoices } = action;
      const quickViewChoices = { ...state.choices };

      Object.keys(configChoices).forEach((choiceId) => {
        const choice = configChoices[choiceId];
        const tagValues = getTagsOfType(choice, 'omsid');
        quickViewChoices[tagValues[0]] = choiceId;
      });

      return {
        ...state,
        choices: quickViewChoices,
      };
    }
    case UPDATE_QUICK_VIEW_PRICING: {
      const { choices } = state;
      const skus = { ...state.skus };

      Object.keys(choices).forEach((skuId) => {
        const choiceId = choices[skuId];
        skus[choiceId] = {
          ...skus[choiceId],
          price: dollars(+action.payload[skuId]),
          skuId,
          isBulkPricing: false,
        };
      });
      return { ...state, skus };
    }
    default:
      return state;
  }
};
